import { Scale } from "../../../utils/Scale"

export class NicPos {
    static titleY = () => Scale.height() * 0.85

    static scientistX = () => Scale.width() * 0.01
    static scientistY = () => Scale.height() * 0.22

    static projectorX = () => Scale.width() * 0.36
    static projectorY = () => Scale.height() * 0.05

    static body1X = () => Scale.width() * 0.493
    static body1Y = () => Scale.height() * 0.125

    static body1X2 = () => Scale.width() * 0.43
    static body1Y2 = () => Scale.height() * 0.33

    static body1X3 = () => Scale.width() * 0.3

    static body2X = () => Scale.width() * 0.56

    static body3X = () => Scale.width() * 0.12
    static body3Y = () => Scale.height() * 0.4

    static body3X2 = () => Scale.width() * 0.35

    static cig1X = () => Scale.width() * 0.575
    static cig1Y = () => Scale.height() * 0.16

    static smokeX = () => Scale.width() * 0.558
    static smokeY = () => Scale.height() * 0.135

    static windpipeX = () => Scale.width() * 0.64
    static windpipeY = () => Scale.height() * 0.31

    static lungsX = () => Scale.width() * 0.56
    static lungsY = () => Scale.height() * 0.42

    static brain1X = () => Scale.width() * 0.61
    static brain1Y = () => Scale.height() * 0.135

}
